export default function getComparePagePlanIds(state) {
  return state.comparePageSetOrRemovePlans;
}
